import React, { Component } from "react";

import Spinner from "../../components/common/Spinner";
import Axios from "axios";
import { CORE_API_ROOT } from "../../config/api-config";

class TestDeleteEmail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
			error: null
		};
	}

	getData() {
		Axios.get(`${CORE_API_ROOT}/test/dev/delete-email`)
			.then(res => {
				this.setState({ data: res.data });
			})
			.catch(err => {
				throw new Error("Email Error");
			});
	}

	componentDidMount() {
		this.getData();
	}

	render() {
		if (!this.state.data) {
			return <Spinner />;
		}

		return <div id="content" dangerouslySetInnerHTML={{ __html: this.state.data }}></div>;
	}
}

export default TestDeleteEmail;
